var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckMark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49982755,12.4954632 L10.6568542,12.5585047 L10.6568542,12.5585047 L10.6568542,-0.0836309448 C10.6568542,-0.864679528 11.2900192,-1.49784451 12.0710678,-1.49784451 C12.8504909,-1.49784451 13.4823382,-0.865997242 13.4823382,-0.0865741412 C13.4823382,-0.0855940979 13.4823372,-0.0846140549 13.4823351,-0.0836340138 L13.4528978,14.0463556 C13.4511719,14.8747809 12.7782014,15.5449532 11.949776,15.5432273 C11.9457416,15.5432189 11.9417072,15.5431942 11.937673,15.5431533 L6.48477197,15.4877925 C5.66232801,15.4794426 5,14.8103561 5,13.9878698 L5,13.9727182 C5,13.156759 5.66146566,12.4952933 6.47742491,12.4952933 C6.48489278,12.4952933 6.49236054,12.49535 6.49982755,12.4954632 Z",
    transform: "rotate(45 9.243 7.03)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckMark);
export default __webpack_public_path__ + "static/media/check-mark.e4b6045c.svg";
export { ForwardRef as ReactComponent };